// Die Schnellerfassungszeile eines Aufmass-Ansatzes (GB-20).
//
// Drei Aufgaben, die alle an derselben Zeile haengen:
//
//  * LIVE-ERGEBNIS waehrend des Tippens — so arbeitet jede Aufmass-App, und auf dem
//    Papierblatt steht die Zahl auch neben dem Ansatz. Eine gefuellte FORMEL wird hier
//    bewusst NICHT ausgewertet: sie laeuft serverseitig ueber Dentaku
//    (Scaffolding::MeasurementFormula, mit Zeichenfilter davor). Eine zweite
//    Rechenmaschine im Browser koennte ein anderes Ergebnis anzeigen als das
//    gespeicherte, und genau diese Abweichung waere in einem pruefbaren Aufmass fatal.
//  * ESCAPE bricht ab (klickt den Abbrechen-Link, der den Frame zuruecklaedt).
//  * REOPEN: beim Abschicken merkt sich der Controller den Erfassungslink, damit
//    measurement-entries die Zeile nach dem Neurendern wieder oeffnet und der Anwender
//    ohne Mausgriff weitertippen kann.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["count", "dimension", "formula", "result", "cancel"]
  static values = { formulaHint: String, reopenHref: String }

  connect() {
    this.calculate()
  }

  calculate() {
    if (!this.hasResultTarget) return

    if (this.hasFormulaTarget && this.formulaTarget.value.trim() !== "") {
      this.resultTarget.textContent = this.formulaHintValue
      return
    }

    const dimensions = this.dimensionTargets
      .map((input) => this.parse(input.value))
      .filter((value) => value !== null)

    if (dimensions.length === 0) {
      this.resultTarget.textContent = "–"
      return
    }

    const count = this.hasCountTarget ? this.parse(this.countTarget.value) : null
    const product = dimensions.reduce((acc, value) => acc * value, count === null ? 1 : count)
    this.resultTarget.textContent = this.format(product)
  }

  cancel(event) {
    if (!this.hasCancelTarget) return
    event.preventDefault()
    this.cancelTarget.click()
  }

  rememberReopen() {
    if (!this.reopenHrefValue) return
    window.__measurementEntryReopen = { href: this.reopenHrefValue, at: Date.now() }
  }

  // Das deutsche Dezimalkomma ist die Schreibweise auf dem Papieraufmass. Der Server
  // ersetzt es ebenfalls, bevor die Zahl das Model erreicht.
  parse(raw) {
    const value = parseFloat(String(raw).replace(",", "."))
    return Number.isFinite(value) ? value : null
  }

  format(value) {
    return value.toLocaleString("de-DE", { minimumFractionDigits: 0, maximumFractionDigits: 3 })
  }
}
